import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Label, Alert,Button } from "reactstrap";
import Page from "components/Page";
import { Textbox,Select} from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import ValoresCotizacionHogar from "./ValoresCotizacionHogar";
import {FetchListarCarritoHogar,FetchGenerarEnviarPdfHogar,FetchTotalesCabeceraCotizadores} from "../../redux/actions/ACarritoProductos";
import ListadoItems from "./CardResumenUbicacion";
import { urlGuardarPasoHogar } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import { urlEliminarUbicacionHogar } from '../../constants/urls'
import { recuperarDatosFacturacionFetch} from "../../redux/actions/aCotizacion";



class CotizacionResumenPaso5 extends Component
{
  constructor(props) {
    super(props);
    this.state = {       
        validate: false,
        correoAlert:false,  
        esAdvance: this.props.carrito.carDescripcionSeguro =='HOGAR ADVANCE',
        loading:true,
        continuarPasoFacturacion: this.props.carrito.continuarDatosFacturacion?this.props.carrito.continuarDatosFacturacion:false  ,
        msgValidarPantallaFacturacion:false,
        msgValidarPantallaFacturacionActualizar:false  
    };
  }

  



   async componentDidMount() {
    window.scrollTo(0, 0)
    //Validar que la cotizacion sea nueva o es recuperacion
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito=queryParams.get('idCarrito');
    if(idCarrito !==undefined && idCarrito !== '' && idCarrito !== null)
    {
      let datosCarritoHogar =
          {
            "empresa":"AIGMETROPOLITANA",
            "idCarrito":idCarrito
          }
      await this.props.listarCarritoHogar(datosCarritoHogar);
    }
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  }

   onEnviar= async (correo)=> {        
    //armar el objeto para enviar información al servicio      
    const datosEnviar = {
      empresa: "AIGMETROPOLITANA",       
      plataforma: "WEB",
      idCarrito: this.props.carrito.mongoCarrito,
      accion: "enviar"  ,
      correo:correo
    }      
    await this.props.guardarGenerarPdfCotizacion(datosEnviar); 

    if(this.props.carritoHogar.setGenerarPdfCotizacionHogar !== undefined && this.props.carritoHogar.setGenerarPdfCotizacionHogar.transaccion === true)
    {
      let { correoAlert} = this.state;
      this.setState({ correoAlert: true });
      //console.log('Se ha enviado la cotizacion al correo')
    }
  }

  onClick = async () => {  
    console.log('urlenviar',this.props.location.search)
    if(this.props.carritoHogar.setCarritoHogar && this.props.carritoHogar.setCarritoHogar.continuarDatosFacturacion === true)
    {
      if(this.props.carritoHogar.setCarritoHogar && this.props.carritoHogar.setCarritoHogar.continuarDatosFacturacionActualizacion === true){
        let resp = await FetchPost({
          url: urlGuardarPasoHogar, param: {
            empresa:"AIGMETROPOLITANA",
            idcarrito:this.props.carrito.mongoCarrito,
            paso:"6",
            mensaje:"Ingreso de Datos de Facturación",
            codigoPasoActual:"datosFacturacionHogar",
            plataforma:"WEB"
          }})
        const { transaccion,ciudades } = resp
        if (transaccion) {
          this.props.history.push({
            pathname: "/datos-facturacion",
            search: `?id=${this.props.carrito.mongoCarrito}`,
            state: { path: this.props.location.pathname, search:  this.props.location.search }
          });
        }   
      }
      else{
        this.setState({msgValidarPantallaFacturacionActualizar:true})
      }
      
    }
    else{
      this.setState({msgValidarPantallaFacturacion:true})
    }
  }

  onClickAgregar = (e) => {
    this.props.history.push({
      pathname: "/cotizacion-hogar",
      search: `?accion=agregar`

    });
  }

  onEliminar = async (codigo) => {
    this.setState({ loading: true });
    
    //Eliminar Item de la cotización 
    let resp = await FetchPost({
      url: urlEliminarUbicacionHogar, param: {
          empresa: "AIGMETROPOLITANA",
          plataforma:"WEB",
          idCarrito: this.props.carrito.mongoCarrito,
          codUbicacion: codigo
      }
    })
    const { transaccion, seEliminoLeadyCarrito } = resp    
    if (transaccion && transaccion === true) {

        if(seEliminoLeadyCarrito === false)
        {
            //listar los productos actuales del carrito
            let datosCarritoHogar =
            {
              "empresa":"AIGMETROPOLITANA",
              "idCarrito":this.props.carrito.mongoCarrito
            }
            await this.props.listarCarritoHogar(datosCarritoHogar);
            //Recuperar los totales de la cabecera
            let datosJSON = {
            empresa:"AIGMETROPOLITANA",
            plataforma:"WEB",
            idCarrito: this.props.carrito.mongoCarrito
          }
          await this.props.datosFacturacion(datosJSON); 
          console.log("dataFacturacion",this.props.dataFacturacion)
          if(this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "")
          {              
            let param={
              pathIcono:this.props.dataFacturacion.pathIconoTotalesCabecera?this.props.dataFacturacion.pathIconoTotalesCabecera:"", 
              totalItems:this.props.dataFacturacion.numItemsCarrito?this.props.dataFacturacion.numItemsCarrito:"0", 
              totalPrima:(this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal)?this.props.dataFacturacion.carValoresTotales.primaTotal:"0.00", 
              ramoCotizador:this.props.dataFacturacion.carDescripcionRamo?this.props.dataFacturacion.carDescripcionRamo:"", 
            }
            await this.props.actualizarTotalesCabecera(param);
          } 
        }
        else{
          this.props.history.push({
            pathname: "/cotizacion-hogar-datospersonales",               
          });
        }
        
    }  
    
      
    this.setState({ loading: false, msgValidarPantallaFacturacion:false,msgValidarPantallaFacturacionActualizar:false });
  }


  render() {  
    let { carritoHogar } = this.props;
    let { correoAlert,loading,msgValidarPantallaFacturacion,msgValidarPantallaFacturacionActualizar} = this.state;
    let agregarUbicacion = (this.props.carritoHogar.setCarritoHogar && this.props.carritoHogar.setCarritoHogar.permitirAgregarUbicaciones && this.props.carritoHogar.setCarritoHogar.permitirAgregarUbicaciones === true)?this.props.carritoHogar.setCarritoHogar.permitirAgregarUbicaciones:false            
    return (
      <LoadingScreen
      loading={carritoHogar.generarPdfCotizacionHogarloading || loading}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text="Cargando..."
      >
      <Page title={this.state.esAdvance ? "Cotización de Hogar Advance": "Cotización de Hogar Protección Total"} breadcrumbs={[{ name: this.state.esAdvance ? "Cotización de Hogar Advance": "Cotización de Hogar Protección Total", active: true }]}>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {`1. Cotización`} </div>
                    <div className="step current"> {`2. Resumen`} </div>
                    <div className="step"> {`3. Confirmación`} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>              
            </Col>
          </Row>
          {agregarUbicacion && !this.state.esAdvance && <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <Button
                className="btn btn-purple"
                onClick={this.onClickAgregar}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                <i className="fa fa-plus-circle" aria-hidden="true" /> AGREGAR UBICACIÓN
            </Button>
            </Col>
          </Row>}
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box" >

                  <Card className="flex-row">                      
                      <CardBody>   
                         <h4 style={{ fontWeight: "bold" }}>Información del Contratante</h4>
                         <p />                                                                 
                          <Row >
                            <Col lg={4} md={12} sm={12} xs={12}><h5 style={{ fontWeight: "bold" }}>Nombre:</h5> </Col>
                            <Col lg={4} md={12} sm={12} xs={12}>{(carritoHogar.setCarritoHogar.carDatosContratante && carritoHogar.setCarritoHogar.carDatosContratante.nombreCompleto ? carritoHogar.setCarritoHogar.carDatosContratante.nombreCompleto : "")}</Col>                                 
                          </Row>
                          <Row >
                            <Col lg={4} md={12} sm={12} xs={12}><h5 style={{ fontWeight: "bold" }}>Cédula / Ruc :</h5></Col>
                            <Col lg={4} md={12} sm={12} xs={12}>{(carritoHogar.setCarritoHogar.carDatosContratante && carritoHogar.setCarritoHogar.carDatosContratante.cliIdentificacion ? carritoHogar.setCarritoHogar.carDatosContratante.cliIdentificacion : "")}</Col>                                 
                          </Row>
                      </CardBody>
                    </Card>
           
                    {carritoHogar.setCarritoHogar  && Object.keys(carritoHogar.setCarritoHogar).length>0 && 
                      carritoHogar.setCarritoHogar.carProductos.map((item, index) => (                                  
                          <ListadoItems key={Math.random()} datosItem={item} indice={index}  metodoEliminar={this.onEliminar}/> 
                      ))                      
                    }
            </Col>

            <Col lg={4} md={12} className="detalle-impuestos-box" >              
              <ValoresCotizacionHogar formEditado={false} esAdvance={this.state.esAdvance} paso={"resumen-cotizacion"} metodo={this.onClick} metodoEnviar={this.onEnviar} cargarTotalesRecuperado={true} habilitarBotonContinuar={false} correoAlert={correoAlert} msgValidarPantallaFacturacion={msgValidarPantallaFacturacion} msgValidarPantallaFacturacionActualizar={msgValidarPantallaFacturacionActualizar}/>              
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
};

const mapStateToProps = state => ({  
  
  carritoHogar : state.datosCarritoHogar,
  carrito : state.datosCarritoHogar.setCarritoHogar,
  dataFacturacion : state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    listarCarritoHogar: (param) => dispatch(FetchListarCarritoHogar(param)),
    guardarGenerarPdfCotizacion: (param) => dispatch(FetchGenerarEnviarPdfHogar(param)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera:(param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionResumenPaso5)
);
